
/* eslint-disable no-restricted-imports */
/* jshint asi:true */

import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import Helmet from "react-helmet"
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";



function InterviewLinkSubmitted(props) {
  const { intl } = props;    

  return (
    <>
    <Helmet>
       <title> VRekruit | Interview</title>
    </Helmet>
         
<section className="bg-white" style={{"overflow":"hidden"}}>
  <Row  >
    <Col sm={12} xs={12} md={12} className="text-center" >
    <img src={"/media/logos/UPDATED_VRekruit _Logo.png"}  className="pt-5 pb-5 mr-auto"    height="80" alt="Company Logo bg-circle" ></img>
    </Col>  
  </Row>
</section>   
    <section className="" style={{"backgroundColor":"#003577","minHeight":"90vh","overflowY":"hidden"}}>
      <h3 className="text-center text-white d-block pt-100"> Link Expired!</h3>
      <h3 className="text-center text-white d-block">Please contact the company to share updated link </h3>
   </section>
    </>
  );
}

export default InterviewLinkSubmitted;